// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"54fc1f72","239":"c43d1ff1","453":"741f4dba","455":"76998569","762":"4ab8df15"}[chunkId] + ".chunk.js";
};